import { render } from "./List.vue?vue&type=template&id=f042091c&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-f042091c"

export default script